// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"b528186d","97":"8348baf5"}[chunkId] + ".css";
};